import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button, Result } from "antd";
import { 
  HomeOutlined, 
  ArrowLeftOutlined, 
  CompassOutlined,
  CarOutlined,
  GlobalOutlined,
  EnvironmentOutlined
} from "@ant-design/icons";
import { 
  FaPlane, 
  FaSuitcase, 
  FaMapMarkedAlt,
  FaUmbrellaBeach,
  FaHotel
} from "react-icons/fa";
import "./NotFound.scss";

const NotFound = () => {
  const navigate = useNavigate();
  const location = useLocation();
  // Check if user is in dashboard, navigate to dashboard home
  const isInDashboard = location.pathname.includes("/dashboard");
  const homePath = isInDashboard ? "/p/dashboard/home" : "/";

  return (
    <div className="not-found-page">
      <div className="not-found-content">
        <div className="not-found-illustration">
          <CompassOutlined className="compass-icon" />
          <div className="travel-elements">
            <div className="travel-icon plane">
              <FaPlane />
            </div>
            <div className="travel-icon suitcase">
              <FaSuitcase />
            </div>
            <div className="travel-icon map">
              <FaMapMarkedAlt />
            </div>
            <div className="travel-icon beach">
              <FaUmbrellaBeach />
            </div>
            <div className="travel-icon hotel">
              <FaHotel />
            </div>
          </div>
        </div>
        <Result
          status="404"
          title="404"
          subTitle={
            <div className="not-found-subtitle">
              <p>נראה שטעינו בדרך...</p>
              <p>הדף שביקשת לא נמצא, אבל אנחנו כאן כדי לעזור לך למצוא את מה שאתה מחפש!</p>
            </div>
          }
          extra={[
            <Button
              type="primary"
              size="large"
              icon={<HomeOutlined />}
              onClick={() => navigate(homePath)}
              key="home"
              className="not-found-home-btn"
            >
              חזרה לדף הבית
            </Button>,
            <Button
              size="large"
              icon={<ArrowLeftOutlined />}
              onClick={() => navigate(-1)}
              key="back"
              className="not-found-back-btn"
            >
              חזרה אחורה
            </Button>,
          ]}
        />
      </div>
    </div>
  );
};

export default NotFound;
